// プランタイプのID（データベース用）
export const PlanType = {
    "Basic": 2,
    "Pro": 1,
    "Trial": 3,
    "Custom": 4,
    "Elite": 5,
    "Lite": 6,
    "Mini": 7,
    "Enterprise": 8,
}

// プランタイプの文字列定数
export const PlanTypeName = {
    Basic: 'Basic',
    Pro: 'Pro',
    Trial: 'Trial',
    Custom: 'Custom',
    Elite: 'Elite',
    Lite: 'Lite',
    Mini: 'Mini',
    Enterprise: 'Enterprise',
} as const

// PlanTypeNameの型（'Enterprise' | 'Basic' | 'Pro' | ...）
export type PlanTypeNameType = typeof PlanTypeName[keyof typeof PlanTypeName]

export const PlanTypeExtension= {
    isEnterprise: (planType: string | PlanTypeNameType | undefined) => planType === PlanTypeName.Enterprise,
    isMini: (planType: string | PlanTypeNameType | undefined) => planType === PlanTypeName.Mini,
    isLite: (planType: string | PlanTypeNameType | undefined) => planType === PlanTypeName.Lite,
    isMiniOrLite: (planType: string | PlanTypeNameType | undefined) => planType === PlanTypeName.Mini || planType === PlanTypeName.Lite,
}

// ロールタイプのID（データベース用）
export const RoleType = {
    "Admin": 1,
    "General": 2,
    "Viewer": 3,
}

// ロールタイプの文字列定数
export const RoleTypeName = {
    Admin: 'Admin',
    General: 'General',
    Viewer: 'Viewer',
} as const

// RoleTypeNameの型（'Admin' | 'General' | 'Viewer'）
export type RoleTypeNameType = typeof RoleTypeName[keyof typeof RoleTypeName]

export const RoleTypeExtension = {
    isAdmin: (roleType: string | RoleTypeNameType) => roleType === RoleTypeName.Admin,
    isGeneral: (roleType: string | RoleTypeNameType) => roleType === RoleTypeName.General,
    isViewer: (roleType: string | RoleTypeNameType) => roleType === RoleTypeName.Viewer,
    getLabel: (roleType: string | RoleTypeNameType) => {
        if (roleType === RoleTypeName.Admin) return '管理者';
        if (roleType === RoleTypeName.General) return '一般';
        if (roleType === RoleTypeName.Viewer) return '閲覧者';
        return roleType;
    }
}

export const EditablePlanTypes = ['4']

// プラン表示順序の定義（UIでの表示順）
export const PlanTypeDisplayOrder = ['Mini', 'Basic', 'Pro', 'Elite', 'Custom', 'Lite', 'Trial', 'Enterprise'];

export const PlanTypeRealEstateType: any = {
    "Rental": {
        "Basic": 2,
        "Pro": 1,
        "Elite": 5,
        "Custom": 4,
        "Mini": 7,
        "Enterprise": 8
    },
    "Distribution": {
        "Lite": 6,
        "Basic": 2,
        "Pro": 1,
        "Elite": 5,
        "Custom": 4,
        "Mini": 7,
        "Enterprise": 8
    },
    "NewlyConstructedDetachedHouse": {
        "Basic": 2,
        "Pro": 1,
        "Elite": 5,
        "Custom": 4,
        "Mini": 7,
        "Enterprise": 8
    }
}

export const PlanTypeLimits: any = {
    "Rental": {
        "Basic": "100",
        "Pro": "300",
        "Elite": "500",
        "Custom": "",
        "Mini": "20",
        "Enterprise": "5000"
    },
    "Distribution": {
        "Lite": "50",
        "Basic": "100",
        "Pro": "300",
        "Elite": "500",
        "Custom": "",
        "Mini": "20",
        "Enterprise": "5000"
    },
    "NewlyConstructedDetachedHouse": {
        "Basic": "50",
        "Pro": "150",
        "Elite": "300",
        "Custom": "",
        "Mini": "20",
        "Enterprise": "5000"
    }
}

export const RealEstateType = {
    "賃貸": "Rental",
    "売買": "Distribution",
    "新築戸建": "NewlyConstructedDetachedHouse"
}

export const PREmailAvailType = {
    "OK": "OK",
    "NG": "NG",
}

export const IsActive = {
    "利用中": "active",
    "停止": "suspended",
    "退会": "withdrawn",
}

export const RoomType = {
    "リビング": "living",
    "ダイニング": "dining",
    "ベッドルーム": "bedroom",
    "ワンルーム": "oneRoom",
}

export const LifestyleType = {
    "スタンダード": "standard",
    "モダン": "modern",
    "ノルディック": "scandinavian",
    "インダストリアル": "industrial",
    "ラグジュアリー": "luxury",
    "ミッドセンチュリー": "midcentury",
}

export const MaxPhotoUpload = 5
export const MaxUploadFileSize = 5*1024*1024
export const MaxUploadFileSizeForImageEditing = 11*1024*1024
export const MaxRegenCount = 5
export const MaxPartialRegenCount = 10

// パノラマステージング用定数
export const PanoramaMaxRegenCount = 2
export const PanoramaMaxFileSize = 20 * 1024 * 1024 // 20MB
export const PanoramaAllowedPlans = ['Basic', 'Pro', 'Elite', 'Custom', 'Enterprise'] as const
export const PanoramaAllowedFormats = ['image/jpeg', 'image/png', 'image/webp'] as const
export const PanoramaMaxExecTime = 70 // 秒
export const PanoramaMaxUpload = 5 // 最大アップロード枚数